<template>
  <div class="fillcontain">
    <search-item @showDialog="showAddTeachingpoint"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          width="100"
          prop="id"
          v-if="false"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="pointName"
          label="分点名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="pointAddress"
          label="分点地址"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="schoolInfoId"
          label="所属校区"
          align="left"
          :filters="this.schoolInfoData"
          :filter-method="filterSchoolInfo"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterSchoolInfo(scope.row)"
              disable-transitions
              >{{ scope.row.schoolInfoId }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="isShow"
          label="是否展示在小程序"
          align="left"
          :filters="fields.isShow.filter.list"
          :filter-method="filterIsShow"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterIsShow(scope.row)"
              :type="scope.row.isShow === 0 ? 'warning' : 'success'"
              disable-transitions
              >{{ scope.row.isShow }}</el-tag
            >
          </template>
        </el-table-column>
        <!-- <el-table-column prop="image" label="分点照片" align="center">
          <template slot-scope="scope">
            <img
              v-show="scope.row.image !== '' && scope.row.image !== null"
              :src="scope.row.image"
              class="picture"
            />
          </template>
        </el-table-column> -->
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditAppointmenttype(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteTeachingpoint(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addTeachingpointDialog.show"
        :isShow="addTeachingpointDialog.show"
        :dialogRow="addTeachingpointDialog.dialogRow"
        :schoolInfoList="addTeachingpointDialog.schoolInfoList"
        @getAppointmenttypeList="getTeachingpoint"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as mutils from "@/utils/mUtils";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { deleteTeachingpoint, getTeachingpoint } from "@/api/teachingpoint";
import { getFormatSchoolInfo } from "@/api/school";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      schoolInfoData: [],
      addTeachingpointDialog: {
        show: false,
        dialogRow: {},
        schoolInfoList: {},
      },
      schoolData: {
        page: 1,
        limit: 20,
      },
      format_isshow_list: {
        0: "否",
        1: "是",
      },
      fields: {
        isShow: {
          filter: {
            list: [
              {
                text: "否",
                value: 0,
              },
              {
                text: "是",
                value: 1,
              },
            ],
          },
        },
      },
      pageTotal: 0,
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getFormatSchoolInfo();
    this.getTeachingpoint();
  },
  methods: {
    filterIsShow(value, item) {
      const type = parseInt(item.isShow);
      return this.format_isshow_list[value] == this.format_isshow_list[type];
    },
    getFormatSchoolInfo() {
      getFormatSchoolInfo().then((res) => {
        console.log(res);
        this.format_schoolinfo_list = res.data.data.format;
        this.schoolInfoData = res.data.data.filter;
        var schoolInfoList = {
          schoolInfoList: this.schoolInfoData,
        };
        this.addTeachingpointDialog.schoolInfoList = schoolInfoList;
      });
    },
    filterSchoolInfo(value, item) {
      return this.format_schoolinfo_list[value] == item.schoolInfoId;
    },
    formatterSchoolInfo(item) {
      const type = parseInt(item.schoolInfoId);
      // console.log(this.format_schoolinfo_list[type]);
      return this.format_schoolinfo_list[type];
    },
    /**
     * 格式化状态
     */
    formatterIsShow(item) {
      const type = parseInt(item.isShow);
      return this.format_isshow_list[type];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    getTeachingpoint() {
      const para = this.schoolData;
      getTeachingpoint(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.teachingpoint;
      });
    },
    // 显示添加预约类型弹窗
    showAddTeachingpoint(val) {
      this.$store.commit("SET_TEACHING_POINT_DIALOG_TITLE", val);
      this.addTeachingpointDialog.show = true;
    },
    hideAddFundDialog() {
      this.addTeachingpointDialog.show = false;
      // this.getTeachingpoint();
    },
    // 上下分页
    handleCurrentChange(val) {
      this.schoolData.page = val;
      this.getTeachingpoint();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.schoolData.limit = val;
      this.getTeachingpoint();
    },
    // 编辑操作方法
    onEditAppointmenttype(row) {
      console.log(row);
      // var para = {}
      var param = Object.assign({}, row);
      this.addTeachingpointDialog.dialogRow = {
        param,
      };
      this.showAddTeachingpoint();
    },
    // 删除数据
    onDeleteTeachingpoint(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteTeachingpoint({ id: row.id }).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content: "删除(" + row.pointName + ")教学分点操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getTeachingpoint();
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_COURSE_SEARCHBTN_DISABLED", isFlag);
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


